import _objectSpread from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import store from '@/store';
import { getToken } from '@/utils/auth';
import router from '@/router';

// 创建axios实例
var service = axios.create({
  baseURL: '',
  // 请求基础URL
  timeout: 600000 // 请求超时时间：10分钟
  // withCredentials: true, // 跨域请求时是否携带cookie
});

// 暴露CancelToken和isCancel方法，用于请求取消
service.CancelToken = axios.CancelToken;
service.isCancel = axios.isCancel;

// 请求拦截器
service.interceptors.request.use(function (config) {
  // 请求前处理：添加token等必要信息
  var token = getToken();
  if (token) {
    config.headers.accessToken = token; // 携带用户token
  }

  // 处理时间相关请求头
  var timeUTC = new Date();
  var GMT = (timeUTC + '').split(' ');
  var UTC = GMT[5];

  // 添加多语言、平台标识等请求头
  config.headers.language = store.state.app.language;
  config.headers.plat = 'MANAGE';
  config.headers.utc = localStorage.getItem('utc');
  config.headers.isTranslate = localStorage.getItem('isTranslate');
  return config;
}, function (error) {
  // 请求错误处理
  console.error('Request Error:', error);
  return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(function (response) {
  // 响应成功处理

  // 如果后台返回新token，则更新客户端token
  if (response.headers.token) {
    store.dispatch('user/updateToken', {
      token: response.headers.token
    });
  }

  // 直接返回响应数据，简化调用
  return response.data;
}, function (error) {
  var _error$response, _error$response2;
  // 响应错误处理

  // 处理token过期情况
  if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
    MessageBox.confirm('登录已过期，请重新登录', '提示', {
      confirmButtonText: '重新登录',
      cancelButtonText: '取消',
      type: 'warning',
      closeOnClickModal: false
    }).then(function () {
      store.dispatch('user/logout').then(function () {
        router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.path
          }
        });
      });
    });
    return Promise.reject(new Error('登录已过期，请重新登录'));
  }

  // 处理请求取消情况
  if (axios.isCancel(error)) {
    console.log('Request canceled:', error.message);
    return Promise.reject(error);
  }

  // 统一显示错误信息
  var errorMessage = ((_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 ? void 0 : _error$response2.message) || error.message || '请求失败';
  Message({
    message: errorMessage,
    type: 'error',
    duration: 5 * 1000
  });
  console.error('Response Error:', error);
  return Promise.reject(error);
});

/**
 * GET请求封装
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @param {object} config - 额外配置
 * @returns {Promise} 请求结果Promise
 */
service.get = function (url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return service(_objectSpread({
    url: url,
    method: 'get',
    params: params
  }, config));
};

/**
 * POST请求封装
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @param {object} config - 额外配置
 * @returns {Promise} 请求结果Promise
 */
service.post = function (url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return service(_objectSpread({
    url: url,
    method: 'post',
    data: data
  }, config));
};

/**
 * PUT请求封装
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @param {object} config - 额外配置
 * @returns {Promise} 请求结果Promise
 */
service.put = function (url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return service(_objectSpread({
    url: url,
    method: 'put',
    data: data
  }, config));
};

/**
 * DELETE请求封装
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @param {object} config - 额外配置
 * @returns {Promise} 请求结果Promise
 */
service.delete = function (url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return service(_objectSpread({
    url: url,
    method: 'delete',
    params: params
  }, config));
};
export default service;